import Text from "@ds/components/Text";
import { LeftIconDark, TopicSearch } from "@icons/mobile";
import { Box } from "@mui/material";
import { useRouter } from "next/router";
import color from "@definitions/mui/color";

type Props = {
  title: string;
  withSearchIcon?: boolean;
  backPath?: string;
  onClickSearchIcon?: () => void;
  searchIconShown?: boolean;
  noBoxShadow?: boolean;
};

const HeaderSupport = ({
  title,
  withSearchIcon = false,
  backPath,
  searchIconShown = true,
  onClickSearchIcon,
  noBoxShadow,
}: Props) => {
  const router = useRouter();

  return (
    <Box
      component="span"
      padding="18px 16px"
      width="100%"
      height="56px"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      position="sticky"
      top={0}
      zIndex={1}
      bgcolor="white"
      boxShadow={noBoxShadow ? "none" : "0px 6px 12px rgba(46, 67, 77, 0.1)"}
    >
      <Box component="span" display="inline-flex" alignItems="center">
        <LeftIconDark
          style={{
            cursor: "pointer",
          }}
          onClick={() => (backPath ? router.push(backPath) : router.back())}
        />

        <Text
          weight="600"
          variant="h3"
          sx={{
            marginLeft: 20,
            fontSize: 18,
            lineHeight: "26px",
            color: color.general.main,
          }}
        >
          {title}
        </Text>
      </Box>
      {withSearchIcon && searchIconShown && (
        <TopicSearch style={{ cursor: "pointer" }} onClick={onClickSearchIcon} />
      )}
    </Box>
  );
};
export default HeaderSupport;
